var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SelectedFiltersView_instances, _SelectedFiltersView_element, _SelectedFiltersView_listElement, _SelectedFiltersView_chipTemplateElement, _SelectedFiltersView_getChipKey, _SelectedFiltersView_getChipElements, _SelectedFiltersView_renderChip, _SelectedFiltersView_initEvents, _SelectedFiltersView_handleChipClick;
import Emitter from '@helpers/Emitter';
import { SELECTED_FILTERS_VIEW_EVENTS } from '@resources/js/components/filters/filterEvents';
// Блок "Вибрані фільтри" в панелі всіх фільтрів (дочірній view FiltersView)
const SELECTORS = {
    list: '.js-filters-selected-list',
    chip: '.js-filters-selected-chip',
    chipText: '.js-filters-selected-chip-text',
    chipStar: '.js-filters-selected-chip-star',
};
const CHIP_TEMPLATE_ID = 'filters-selected-chip-template';
class SelectedFiltersView extends Emitter {
    constructor(containerElement) {
        super();
        _SelectedFiltersView_instances.add(this);
        _SelectedFiltersView_element.set(this, void 0);
        _SelectedFiltersView_listElement.set(this, void 0);
        _SelectedFiltersView_chipTemplateElement.set(this, void 0);
        __classPrivateFieldSet(this, _SelectedFiltersView_element, containerElement, "f");
        if (!__classPrivateFieldGet(this, _SelectedFiltersView_element, "f"))
            throw new Error('Selected filters container not found');
        __classPrivateFieldSet(this, _SelectedFiltersView_listElement, __classPrivateFieldGet(this, _SelectedFiltersView_element, "f").querySelector(SELECTORS.list), "f");
        __classPrivateFieldSet(this, _SelectedFiltersView_chipTemplateElement, document.getElementById(CHIP_TEMPLATE_ID), "f");
        __classPrivateFieldGet(this, _SelectedFiltersView_instances, "m", _SelectedFiltersView_initEvents).call(this);
    }
    // наявні чипси оновлюємо на місці
    // з DOM прибираємо лише зниклі, нові додаємо в кінець — порядок тримає DOM,
    // щойно обраний фільтр завжди стає останнім у ряду
    render(chips) {
        const chipKeys = chips.map(chip => __classPrivateFieldGet(this, _SelectedFiltersView_instances, "m", _SelectedFiltersView_getChipKey).call(this, chip));
        // прибираємо чипси, яких немає в новому наборі
        __classPrivateFieldGet(this, _SelectedFiltersView_instances, "m", _SelectedFiltersView_getChipElements).call(this).forEach(chipElement => {
            if (!chipKeys.includes(chipElement.dataset.key))
                chipElement.remove();
        });
        const chipElements = __classPrivateFieldGet(this, _SelectedFiltersView_instances, "m", _SelectedFiltersView_getChipElements).call(this);
        chips.forEach((chip, index) => {
            var _a;
            const chipElement = (_a = chipElements.find(element => element.dataset.key === chipKeys[index])) !== null && _a !== void 0 ? _a : __classPrivateFieldGet(this, _SelectedFiltersView_instances, "m", _SelectedFiltersView_renderChip).call(this, chip);
            chipElement.classList.toggle('removed', chip.state === 'removed');
            if (!chipElement.isConnected)
                __classPrivateFieldGet(this, _SelectedFiltersView_listElement, "f").append(chipElement);
        });
        __classPrivateFieldGet(this, _SelectedFiltersView_element, "f").classList.toggle('hidden', !chips.length);
    }
}
_SelectedFiltersView_element = new WeakMap(), _SelectedFiltersView_listElement = new WeakMap(), _SelectedFiltersView_chipTemplateElement = new WeakMap(), _SelectedFiltersView_instances = new WeakSet(), _SelectedFiltersView_getChipKey = function _SelectedFiltersView_getChipKey({ category, value }) {
    return `${category}-${value}`;
}, _SelectedFiltersView_getChipElements = function _SelectedFiltersView_getChipElements() {
    return Array.from(__classPrivateFieldGet(this, _SelectedFiltersView_listElement, "f").querySelectorAll(SELECTORS.chip));
}, _SelectedFiltersView_renderChip = function _SelectedFiltersView_renderChip(chip) {
    var _a;
    const chipElement = __classPrivateFieldGet(this, _SelectedFiltersView_chipTemplateElement, "f").content.firstElementChild.cloneNode(true);
    chipElement.dataset.key = __classPrivateFieldGet(this, _SelectedFiltersView_instances, "m", _SelectedFiltersView_getChipKey).call(this, chip);
    chipElement.dataset.category = chip.category;
    chipElement.dataset.value = String(chip.value);
    const textElement = chipElement.querySelector(SELECTORS.chipText);
    textElement.textContent = chip.label;
    // у чипсі є іконка зірки — потрібна лише для категорії stars
    if (chip.category !== 'stars')
        (_a = chipElement.querySelector(SELECTORS.chipStar)) === null || _a === void 0 ? void 0 : _a.remove();
    return chipElement;
}, _SelectedFiltersView_initEvents = function _SelectedFiltersView_initEvents() {
    __classPrivateFieldGet(this, _SelectedFiltersView_listElement, "f").addEventListener('click', __classPrivateFieldGet(this, _SelectedFiltersView_instances, "m", _SelectedFiltersView_handleChipClick).bind(this));
}, _SelectedFiltersView_handleChipClick = function _SelectedFiltersView_handleChipClick(event) {
    const chipElement = event.target.closest(SELECTORS.chip);
    if (!chipElement)
        return;
    // зупиняємо подію, щоб не закрилась модалка фільтрів
    // "новий" чипс після кліку зникає з DOM, і Modal сприймає це як клік по бекдропу
    event.stopPropagation();
    const { category, value } = chipElement.dataset;
    this.emit(SELECTED_FILTERS_VIEW_EVENTS.CHIP_CLICK, {
        category,
        value: Number(value),
    });
};
export default SelectedFiltersView;
